import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import { hasAnyPermission } from "shared/imports/permissionFunctions"

// components
import {
    PacClassicPacOfficeStateFilter,
    PacClassicPacOrganizationCandidateLastNameFilter,
    PacClassicPacOrganizationPacClassicPacOfficeFilter,
    PacClassicPacOrganizationCandidateDistrictFilter,
    PacClassicPacOrganizationElectionYearFilter,
    PacClassicPacOrganizationIsIncumbentFilter,
    PacClassicPacOrganizationPacLimitTypeMultiFilter,
    PacClassicPacOrganizationPacPartyTypeMultiFilter,
    PacClassicPacOrganizationIsActiveFilter,
    PacClassicPacOrganizationFilterIdFilter,
    PacClassicPacOrganizationPacClassicPacLegislatorFilter,
} from "shared/search/containers/Filter/PacClassicPacOrganizationFilters"
import { createPacClassicPacTransactionAmountFilter } from "shared/search/containers/Filter/PacClassicPacTransactionFilters"
type Props = {
    displayLabel?: string
    filters?: Array<React.JSX.Element>
    helpText?: string
    uniqueFilterGroupId?: string
}

export const PacClassicPacOrganizationPACActivityFilterGroup = (props: Props) => genericFilterGroup(props)
PacClassicPacOrganizationPACActivityFilterGroup.defaultProps = {
    filters: [
        PacClassicPacOrganizationPacLimitTypeMultiFilter,
        PacClassicPacOrganizationPacPartyTypeMultiFilter,
        PacClassicPacOrganizationIsActiveFilter,
        PacClassicPacOrganizationFilterIdFilter,
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.pac_hybrid])
            ? [
                  createPacClassicPacTransactionAmountFilter({
                      quorumDataType: DjangIO.app.models.QuorumDataType.pacc_pac_organization,
                  }),
              ]
            : []),
    ],
    uniqueFilterGroupId: "pacClassicPacOrganizationPACActivityFilterGroup",
    displayLabel: "PAC Activity",
    helpText: "Filter by PAC Activity.",
}

export const PacClassicPacOrganizationCandidateFilterGroup = (props: Props) => genericFilterGroup(props)
PacClassicPacOrganizationCandidateFilterGroup.defaultProps = {
    filters: [
        PacClassicPacOrganizationCandidateLastNameFilter,
        PacClassicPacOrganizationPacClassicPacOfficeFilter,
        PacClassicPacOfficeStateFilter,
        PacClassicPacOrganizationCandidateDistrictFilter,
        PacClassicPacOrganizationElectionYearFilter,
        PacClassicPacOrganizationIsIncumbentFilter,
    ],
    uniqueFilterGroupId: "pacClassicPacOrganizationCandidateFilterGroup",
    displayLabel: "Candidate",
    helpText: "Filter by Candidate Metadata.",
}

export const PacClassicPacOrganizationOfficialsFilterGroup = (props: Props) => genericFilterGroup(props)
PacClassicPacOrganizationOfficialsFilterGroup.defaultProps = {
    filters: [PacClassicPacOrganizationPacClassicPacLegislatorFilter],
    uniqueFilterGroupId: "pacClassicPacOrganizationOfficialsFilterGroup",
    displayLabel: "Officials",
    helpText: "Filter by Official.",
}
